import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'
import React from 'react'
import logoVerosenso from '../../../assets/fashion/pdf/logo-versosenso.png';

const styles = StyleSheet.create({
  header: {
    position: 'absolute',
    top: 15,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderBottomWidth: 1.5,
    borderBottomColor: '#000',
    paddingTop: 5,
    paddingBottom: 26,
    minHeight: 45,
  },
  logoContainer: {
    alignItems: 'flex-start',
  },
  logo: {
    width: 140,
    height: 42,
    objectFit: 'contain',
  },
  headerContact: {
    textAlign: 'right',
  },
  email: {
    fontSize: 9,
    marginTop: 16,
    color: '#000',
  },
  contact: {
    fontSize: 9,
    color: '#000',
  },
  versionText: {
    fontSize: 9,
    color: '#000',
    marginTop: 4,
  },
})

const HeaderFashionOfPDF = ({ version }: { version?: number }) => {
  return (
    <View fixed style={styles.header} >
      <View style={styles.logoContainer}>
        <Image src={logoVerosenso} style={styles.logo} />
      </View>
      <View style={styles.headerContact}>
        <Text style={styles.email}>E-mail: qualidade@dustre.com.br</Text>
        <Text style={styles.contact}>Tel.: (11) 4556-0929 | Cel.: (11) 96165-6555</Text>
        {version && <Text style={styles.versionText}>Versão {version}</Text>}
      </View>
    </View>
  )
}

export default HeaderFashionOfPDF
